import {ChangeDetectionStrategy, Component, Injector} from '@angular/core';
import {PlayerContainer} from '../../player/player.container';
import {mergeAll, mergeWith, Observable, of, shareReplay, takeUntil, timer} from 'rxjs';
import {catchError, delay, repeat, switchMap} from 'rxjs/operators';
import {Log, LogTag} from "../../services/Log";

@Component({
  selector: 'app-playlist',
  template: '<div #component><template #playercontainer></template></div>',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlaylistComponent extends PlayerContainer {
  pages: any;
  index: number = -1;
  defaultDuration;
  duration;

  constructor(protected  injector: Injector) {
    super(injector);

  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        this.index = 0;
        if (this.editMode) {
          return this.showPage();
        }
        this.loadStat();
        return of('a');
      }),
      catchError(err => this.logError(err)),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  play(): Observable<any> {
    if (this.editMode) {
      this.display(true);
      return of('play');
    }

    this.duration = 0;
    const next$ = of('next').pipe(
      switchMap( a=> of('delay').pipe(delay(this.duration))),
      repeat()
    )
    const loop$ = next$.pipe(
      switchMap( a=> this.showPage())
    )

    return super.play().pipe(
      mergeWith(loop$)
    )
  }

  getPage(): Observable<any> {
    const logInfo = Log.getLogInfo("PlaylistComponent", "getPage", []);
    return new Observable<any>( sub => {
      this.defaultDuration = this.data.Playlist[0].$.duration;
      this.pages = this.data.Playlist[0].Page;
      if (this.pages==null || this.pages.length==0) {
        Log.w(logInfo, LogTag.PLAYER, 'Playlist is empty');
        this.showMsg(this.playerObject.$.label, 'Playlist is empty');
        sub.next(null);
        sub.complete();
      } else {
        this.showMsg(null, null);

        const page = this.pages[this.index];
        let player = page.Player[0];
        let dur = page.$.duration;
        if (dur==null || dur == "") {
          dur = this.defaultDuration;
        }
        this.duration = Number(dur * 1000);
        this.index++;
        if (this.index >= this.pages.length) {
          this.index = 0;
        }
        sub.next(player);
        sub.complete();
      }
    })
  }
}
